import React from "react";
import { DPButton } from "Components/DP";
import mutations from "Shared/mutations";
import queries from "Shared/queries";
import { useMutation } from "@apollo/client";
import useStyles from "./styles";
import { UpdateUserStatusMutation, UpdateUserStatusMutationVariables } from "generated/graphql";

type Props = {
  employeeProfileId: string;
  providerAccountId: string;
  isEnabled: boolean;
  isUserTerminated: boolean;
};

const ActivateDeactivateButton = ({ employeeProfileId, providerAccountId, isEnabled, isUserTerminated }: Props) => {
  const classes = useStyles();
  const [updateUserStatusFn] = useMutation<
    UpdateUserStatusMutation, UpdateUserStatusMutationVariables
  >(mutations.UPDATE_USER_STATUS, {
    variables: {
      providerAccountId,
      isEnabled: !isEnabled,
    },
  });

  const onDisableClick = async () => {
    await updateUserStatusFn({
      refetchQueries: [
        {
          query: queries.GET_EMPLOYEE_PROFILE,
          variables: {
            employeeProfileId,
          },
        },
      ],
    });
  };

  return (
    <DPButton
      align="right"
      onClick={onDisableClick}
      className={classes.button}
      disabled={isUserTerminated}
    >
      {isEnabled ? "disable" : "enable"}
    </DPButton>
  );
};

export default ActivateDeactivateButton;
